import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VoucherService from '../../api/services/VoucherService';
import MainPagetitle from '../../layouts/MainPagetitle';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const AddVoucher = () => {
  const navigate = useNavigate();

  const [file, setFile] = useState()
  const [Germanfile, setGermanFile] = useState()
  
  const [error, setError] = useState([]);
  const [description, setDescription] = useState("");
  const [Germandescription, setGermanDescription] = useState("");
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {

    }
    else {
      navigate('/')
    }
  }, []);
  const handleEditorChange = (e, editor) => {
    const data = editor.getData()
    setDescription(data);
  }
  const handleEditorChangeGerman = (e, editor) => {
    const data = editor.getData()
    setGermanDescription(data);
  }

  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var blog_image = fileReader.result
      setFile(blog_image)
    }
  }
  const onFileChange1 = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var blog_image = fileReader.result
      setGermanFile(blog_image)
    }
  }
  
  const onSubmitForm = async (event) => {
    event.preventDefault();
    try {
      var userData = {
        "title": event.target.title.value,
        "de_title": event.target.de_title.value,
        "description": description,
        "de_description": Germandescription,
        "startprice": event.target.startprice.value,
        "endprice": event.target.endprice.value,
        "voucher_image": file ? file.split(',')[1] : "",
        "de_voucher_image":Germanfile ? Germanfile.split(',')[1]:""
      }
      let responseData = await VoucherService.store(userData).json()
      if (responseData.status === true) {
        navigate("/admin/vouchers");
      }
      setError(responseData.errors)
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message)
      }
    }

  };

  return (
    <>
      <MainPagetitle mainTitle="Add Voucher" pageTitle={'Add Voucher'} parentTitle={'Home'} />
      <div className="container-fluid">
        <form className="form-valide" onSubmit={onSubmitForm}>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Add Voucher</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label"> English Description <span className="text-danger">*</span></label>
                      <div className="custom-ekeditor">
                        <CKEditor
                          editor={ClassicEditor}
                          name="description"
                          onChange={handleEditorChange}
                        />
                      </div>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label"> German Description <span className="text-danger">*</span></label>
                      <div className="custom-ekeditor">
                        <CKEditor
                          editor={ClassicEditor}
                          name="de_description"
                          onChange={handleEditorChangeGerman}
                        />
                      </div>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label"> English Image <span className="text-danger">*</span></label>
                      <img className="img-drop-area" height={file ? 100 : 0} width={file ? 100 : 0} src={file} alt='' />
                      <input type="file" className="form-control" name='blog_image' id="val-number" accept="image/png, image/jpeg" onChange={onFileChange} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label"> German Image <span className="text-danger">*</span></label>
                      <img className="img-drop-area" height={Germanfile ? 100 : 0} width={Germanfile ? 100 : 0} src={Germanfile} alt='' />
                      <input type="file" className="form-control" name='de_blog_image' id="val-number" accept="image/png, image/jpeg" onChange={onFileChange1} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Start Price<span className="text-danger">*</span></label>
                      <input type="number" className="form-control" name='startprice' id="startprice" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >End Price<span className="text-danger">*</span></label>
                      <input type="number" className="form-control" name='endprice' id="endprice" placeholder="" />
                    </div>
                  </div>
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                  </div>
                  <span class="span-error">{error}</span>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>

    </>
  );
};
export default AddVoucher;